<template>
    <div class="thumbnail__info-table">
        <template v-if="itemType === 'course'">
            <span class="thumbnail__info -trainer" v-if="instructors !== null && instructors !== undefined">{{ instructors }}</span>
            <span class="thumbnail__info -recording" v-if="isRecording(entity)" v-html="$t('CourseListFilter.recording')"></span>
            <span class="thumbnail__info -podcast" v-if="isPodcast(entity)" v-html="$t('CourseListFilter.podcast')"></span>
            <span class="thumbnail__info -event" v-if="isLive(entity)" v-html="$t('CourseListFilter.live')"></span>
            <span class="thumbnail__info -digital-classroom" v-if="isDigitalClassRoomTraining(entity)" v-html="$t('CourseListFilter.virtual_classroom')"></span>
            <span class="thumbnail__info -date" v-if="isLive(entity) || isDigitalClassRoomTraining(entity)">
                <TotemLiveEventDate
                    :date="getLiveEventDate(entity)"
                    :time="getLiveEventTime(entity)"
                    v-if="isLive(entity)"
                    :isCourseItem="true"
                />
                <TotemLiveEventDate
                    v-else-if="isDigitalClassRoomTraining(entity)"
                    :date="getClosestDigitalClassRoomEvent.date"
                    :time="getClosestDigitalClassRoomEvent.time"
                    :isCourseItem="true"
                />
            </span>
            <span class="thumbnail__info -duration" v-if="!isLive(entity) && videoDuration">{{ videoDuration }}</span>
        </template>
        <template v-if="itemType === 'collection'">
            <span class="thumbnail__info -collection" v-html="$t('CourseListFilter.collection')"></span>
            <span class="thumbnail__info -courseamount">{{ itemsLength }}</span>
            <span class="thumbnail__info -duration">{{ convertMinutesToHours(totalDuration) }}</span>
        </template>
        <template v-if="itemType === 'learningpath'">
            <span class="thumbnail__info -learningpath" v-html="$t('LearningPath.course_learningpath')"></span>
            <span class="thumbnail__info -courseamount">{{ itemsLength }}</span>
            <span class="thumbnail__info -duration">{{ convertMinutesToHours(totalDuration) }}</span>
        </template>
    </div>
</template>

<script>
    import ThumbnailInfoHelper from 'components/shared/global-courses-items/helper/thumbnail-info-helper'
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'

    export default {
        name: 'thumbnail-info-table',
        mixins: [ ThumbnailInfoHelper, convertMinutesToHours ]
    }
</script>

<style lang="scss">
    .thumbnail {
        &__info-table {
            font-family: Nunito-Regular, sans-serif;
            font-size: 1.3rem;
            line-height: 1.8rem;
            color: $emperor;
            margin: 10px 0 15px;

            [class*="mobile"] & {
                margin: 0 0 10px;
            }
        }

        &__info {
            display: inline-block;
            position: relative;
            margin: 5px 12px 0 18px;

            &:before {
                position: absolute;
                display: inline-block;
                left: -18px;
            }

            &.-trainer {
                margin: 5px 12px 0 14px;
                &:before {
                    content: url('../../../../assets/images/thumbnails/trainer.svg');
                    width: 10px;
                    height: 12px;
                    top: 1px;
                    left: -14px;
                }
            }

            &.-recording {
                &:before {
                    content: '\e94c';
                    font-family: 'icomoon' !important;
                }
            }

            &.-podcast {
                &:before {
                    content: '\e94e';
                    font-family: icomoon;
                }
            }

            &.-event {
                &:before {
                    content: '\e94d';
                    font-family: icomoon;
                }
            }

            &.-digital-classroom {
                &:before {
                    content: url('../../../../assets/images/thumbnails/globe.svg');
                    width: 12px;
                    height: 12px;
                    top: 2px;
                }
            }

            &.-collection {
                &:before {
                    content: "\e92e";
                    font-family: icomoon;
                }
            }

            &.-learningpath {
                &:before {
                    content: "\e949";
                    font-family: icomoon;
                    color: $orange;
                }
            }

            &.-courseamount {
                &:before {
                    content: "\e91c";
                    font-family: icomoon;
                }
            }

            &.-date {
                margin: 0;
            }

            &.-duration {
                margin: 5px 12px 0 16px;
                &:before {
                    content: '\e932';
                    font-family: icomoon;
                    top: -1px;
                    left: -16px;
                }
            }
        }
    }
</style>
